// extracted by mini-css-extract-plugin
module.exports = {"results":"ResultsTable_results__1oQ1Z","sortable":"ResultsTable_sortable__1J7Gf","asc":"ResultsTable_asc__vv6X6","desc":"ResultsTable_desc__gFaVG"};